import { render, staticRenderFns } from "./side-nav-outer-toolbar.vue?vue&type=template&id=8dcaf8d8"
import script from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&lang=js"
import style0 from "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=8dcaf8d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports